"use strict";

module.exports = {
	ForgotPassword: require('./ForgotPassword'),
	Login: require('./Login'),
	Signup: require('./signup'),
	Account: require('./account'),
	ResetPassword: require('./ResetPassword')
};